import { useLocation } from "react-router-dom";
import { useAppSelector } from "../store/store";
import { useTranslation } from "react-i18next";
import { IActionLabel } from "../models/theme";

export const usePage = () => {
  const {
    i18n: { language: lang },
  } = useTranslation();

  const theme = useAppSelector((state) => state.theme);

  const actions = theme.actions;

  const { pathname } = useLocation();

  const actionPage = actions
    ? actions.find((action) => pathname.includes(action.link)) || null
    : null;

  const pageTitle =
    actionPage && actionPage.label
      ? actionPage.label[lang as keyof IActionLabel] || null
      : null;

  return { actionPage, pageTitle };
};
